<template>
  <div class="im-notify">
    <div class="notify-msg">{{ message }}</div>
    <div class="notify-btn">
      <el-button type="info" size="mini" @click="handleCancel">取消</el-button>
      <el-button type="danger" size="mini" @click="handleConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ImNotify',
  components: {},
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      message: state => state.imConfirm.message
    })
  },
  watch: {
  },
  methods: {
    ...mapActions(['imConfirmResolve', 'imConfirmReject']),
    handleCancel () {
      this.imConfirmReject()
    },
    handleConfirm () {
      this.imConfirmResolve()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .im-notify {
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: center;
  }
  .notify-msg {
    padding-top: 30px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .notify-btn {
    flex: 1;
    display: flex;
    align-items: flex-end;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/notify/ImNotify.vue